import { Component, OnInit } from '@angular/core';
import { DatasService } from 'src/app/services/datas.service';
import { CurrentService } from '../../services/current.service';
import { CONFIG_CONTEXT } from 'src/app/enum/config-context.enum';
import { TunnelDataStore } from 'src/app/stores/tunnel/tunnel-data.store';
import { TunnelNavigationStore } from 'src/app/stores/tunnel/tunnel-navigation.store';
import { Router } from '@angular/router';

@Component({
  selector: 'ng-casto-storage',
  templateUrl: './storage.component.html',
  host: { class: 'container' },
})
export class StorageComponent implements OnInit {
  currentTabId: number = 1;

  constructor(
    public current: CurrentService,
    public datas: DatasService,
    public tunnelDataStore: TunnelDataStore,
    private readonly router: Router,
    private readonly tunnelNavigationStore: TunnelNavigationStore
  ) { }

  ngOnInit(): void {
    this.current.reset();
    this.tunnelDataStore.resetState(false);
    this.tunnelDataStore.setMainContext(CONFIG_CONTEXT.STORAGE);
  }

  nextTab() {
    this.currentTabId++;
  }

  skipStep() {
    if (this.tunnelNavigationStore.isTunnelValue) {
      this.tunnelNavigationStore.nextStep();
    } else {
      this.router.navigateByUrl('/rangements/configuration');
    }
  }
}
